angular.module('impactx.panel').controller('ThemeWorldPanelCtrl', [
    'TranslationService',
    'dataGen',
    '$context',
    'ToastService',
    '$redirect',
    'searchFilter',
    'ThemeWorldService',
    '$mdTheming',
    'AppConfiguration',
    ThemeWorldPanelCtrl]);

function ThemeWorldPanelCtrl(TranslationService, dataGen, $context, ToastService, $redirect, searchFilter, ThemeWorldService, $mdTheming, AppConfiguration) {
    var self = this;
    self.trns = {
        themeWorld: TranslationService.get('themeWorld')
    };

    self.showPanelLabel = AppConfiguration.get('showPanelLabels');
    
    self.getThemeColor = function() {
        if (self.themeWorld.theme) {
            return $mdTheming.PALETTES[self.themeWorld.theme][500].hex
        }
    };

    self.activateThemeWorldSearch = function(id) {
        ThemeWorldService.activateThemeWorldSearch(id);
    };
}